import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import FormSection from "../../shared/component/form/FormSection";
import {toast} from "react-toastify";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import {
    END_OF_DAY_TIME,
    HOUR_AND_MINUTE,
    MENU_DISPLAY_TEMPLATE,
    MENU_DISPLAY_TYPE,
    PRICE_CALCULATION_METHOD,
    PURCHASE_ORDER_ITEM_LIST_FIELDS,
    RETAIL_HOUR_AND_MINUTE,
    SERVICE_CHARGE_DEFAULT_VALUE,
    SERVICE_CHARGE_OPTIONS,
    TILL_PRICE_CALCULATION_METHOD,
    YESNO,
} from "../../shared/utils/Constants";
import {InputNumber} from "primereact/inputnumber";
import {ColorPicker} from "primereact/colorpicker";
import SettingsTabNav from "../../shared/component/form/SettingsTabNav";
import {MultiSelect} from "primereact/multiselect";
import DepartmentService from "../../shared/service/DepartmentService";
import MerchantUserService from "../../shared/service/MerchantUserService";
import '../../shared/styles/SettingsPage.css';

const defaultMerchantBranchSettings = {
    id: '',
    email: null,
    endOfDayHour: "00",
    isAutoEndOfDay: true,
    tillPriceCalculationMethod: "NEAREST_9",
    departmentId: null,
    minStock: null,
    printQueueTillUserBssId: null,
    profitMargin: null,
    defaultCostPricePercentage: 0,
    purchaseOrderItemListFields: []
};

export default class BranchSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            merchantBranchSettings: defaultMerchantBranchSettings,
            merchantBranchSettingsTemp: defaultMerchantBranchSettings,
            marketPlaceSaveButtonRender: true,
            endOfDaySaveButtonRender: true,
            deliverySaveButtonRender: true,
            branchSchedulesButtonRender: true,
            productPriceButtonRender: true,
            orderDisplaySettingsButtonRender: true,
            activeTabIndex: 0,
            activeScheduleTabIndex: 0,
            departmentList: [],
            tillUserList: [],
        }
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
        this.departmentService = new DepartmentService();
        this.merchantUserService = new MerchantUserService();
    }

    componentDidMount() {
        this.departmentService.findAll().then(response => this.setState({departmentList: response}));
        this.merchantUserService.getTillUsers(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    tillUserList: response,
                });
            }

        });

        let obj1 = Object.assign({}, defaultMerchantBranchSettings);
        this.setState({
            merchantBranchSettings: obj1,
            marketPlaceSaveButtonRender: false,
            endOfDaySaveButtonRender: false,
            deliverySaveButtonRender: false,
            branchSchedulesButtonRender: false,
            productPriceButtonRender: false,
            orderDisplaySettingsButtonRender: false,
            merchantBranchSettingsTemp: Object.assign({}, obj1)
        });


        this.findByBranchId(-1);


    }

    findByBranchId = (id) => {
        this.merchantBranchSettingsService.findByBranchId(id).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                const normalizedResponse = {
                    ...response,
                    tillPriceCalculationMethod: response.tillPriceCalculationMethod || "NEAREST_9"
                };
                this.setState({
                    merchantBranchSettings: normalizedResponse,
                    merchantBranchSettingsTemp: Object.assign({}, normalizedResponse)
                });
            }
        });
    }

    render() {
        return (
            <div className="settings-page settings-page--full settings-page--branch-settings col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Branch Settings</h1>
                        </div>
                        <div className="settings-page__panel">
                            <SettingsTabNav
                                activeIndex={this.state.activeTabIndex}
                                onTabChange={(index) => this.setState({activeTabIndex: index})}
                                tabs={[
                                    {id: 'eod', label: 'EOD Settings', content: this.endOfSettingDetails()},
                                    {id: 'basket', label: 'Basket Settings', content: this.basketSettingDetails()},
                                    {id: 'schedules', label: 'Branch Schedules', content: this.branchSchedules()},
                                    {id: 'product-price', label: 'Product Price', content: this.productPrice()},
                                    {id: 'marketplace', label: 'Market Place Settings', content: this.marketPlaceSettings()},
                                    {id: 'order-display', label: 'Order Display Settings', content: this.orderDisplaySettings()},
                                    {id: 'invoice', label: 'Invoice', content: this.defaultData()},
                                ]}
                            />
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    endOfSettingDetails() {
        return (
            <FormSection>
                <div className="settings-page__filter-row settings-page__filter-row--cols-3 settings-page__form-fields settings-page__branch-eod-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="eod-email">
                                <Translate contentKey="merchantAccount.emailAddress">EOD Email
                                    Address</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                id="eod-email"
                                type="text"
                                className="form-control"
                                name="email"
                                disabled={!this.state.endOfDaySaveButtonRender}
                                validate={{
                                    minLength: {
                                        "value": 5, "errorMessage": "Not Valid Email"
                                    }, maxLength: {
                                        value: 50,
                                        errorMessage: "You can enter up to 50 characters in this field."
                                    }
                                }}
                                value={this.state.merchantBranchSettings.email}
                                onChange={this.__handleChange}/>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="is-auto-end-of-day">
                                <Translate contentKey="merchantAccount.emailAddress">Auto End Of
                                    Day</Translate>
                            </Label>
                            <AvField
                                id="is-auto-end-of-day"
                                type="select"
                                className="form-control"
                                name="isAutoEndOfDay"
                                disabled={!this.state.endOfDaySaveButtonRender}
                                value={this.state.merchantBranchSettings.isAutoEndOfDay}
                                onChange={this.__handleChange}>
                                {YESNO.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="end-of-day-hour">
                                <Translate contentKey="merchantAccount.emailAddress">End Of Day
                                    Hour</Translate>
                            </Label>
                            <AvField
                                id="end-of-day-hour"
                                type="select"
                                className="form-control"
                                name="endOfDayHour"
                                disabled={!this.state.endOfDaySaveButtonRender}
                                value={this.state.merchantBranchSettings.endOfDayHour}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {END_OF_DAY_TIME.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {this.state.endOfDaySaveButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({
                                endOfDaySaveButtonRender: true,
                                deliverySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {this.state.endOfDaySaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveMerchantBranchSettings("EOF");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}

                    {this.state.endOfDaySaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.merchantBranchSettingsTemp;
                            this.setState({
                                merchantBranchSettings: Object.assign({}, obj1),
                                endOfDaySaveButtonRender: false,
                                deliverySaveButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    };

    productPrice() {
        return (
            <FormSection title="Web Product Price Calculation">
                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="price-calculation-method">
                                <Translate contentKey="merchantAccount.emailAddress">Calculation
                                    Method</Translate>
                            </Label>
                            <AvField
                                id="price-calculation-method"
                                type="select"
                                className="form-control"
                                name="priceCalculationMethod"
                                disabled={!this.state.productPriceButtonRender}
                                value={this.state.merchantBranchSettings.priceCalculationMethod}
                                onChange={this.__handleChange}>
                                {PRICE_CALCULATION_METHOD.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="price-calculation-rate">
                                <Translate contentKey="productfirstName">Calculation Rate</Translate>
                            </Label>
                            <AvField
                                id="price-calculation-rate"
                                name="priceCalculationRate"
                                type="number"
                                disabled={!this.state.productPriceButtonRender || this.state.merchantBranchSettings.priceCalculationMethod == "NO_CALCULATION"}
                                value={this.state.merchantBranchSettings.priceCalculationRate}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {this.state.productPriceButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({
                                productPriceButtonRender: true,
                                deliverySaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {this.state.productPriceButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveMerchantBranchSettings("PRODUCTPRICE");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}

                    {this.state.productPriceButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.merchantBranchSettingsTemp;
                            this.setState({
                                merchantBranchSettings: Object.assign({}, obj1),
                                deliverySaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    };
    defaultData() {
        return (
            <FormSection title="Default Data">
                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="department-id">
                                <Translate contentKey="merchantAccount.emailAddress">Default Department</Translate>
                            </Label>
                            <AvField
                                id="department-id"
                                type="select"
                                disabled={!this.state.productPriceButtonRender}
                                className="form-control"
                                name="departmentId"
                                value={this.state.merchantBranchSettings.departmentId}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {this.state.departmentList.map(element => (
                                    <option value={element.id} key={element.id}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="min-stock">
                                <Translate contentKey="productfirstName">Default Min Stock</Translate>
                            </Label>
                            <InputNumber
                                inputId="min-stock"
                                name="minStock"
                                disabled={!this.state.productPriceButtonRender}
                                value={this.state.merchantBranchSettings.minStock}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="profit-margin">
                                <Translate contentKey="productfirstName">Default Profit Margin</Translate>
                            </Label>
                            <InputNumber
                                inputId="profit-margin"
                                name="profitMargin"
                                disabled={!this.state.productPriceButtonRender}
                                value={this.state.merchantBranchSettings.profitMargin}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="default-cost-price-percentage">
                                <Translate contentKey="productfirstName">Default Cost Price Percentage</Translate>
                            </Label>
                            <InputNumber
                                inputId="default-cost-price-percentage"
                                name="defaultCostPricePercentage"
                                disabled={!this.state.productPriceButtonRender}
                                value={this.state.merchantBranchSettings.defaultCostPricePercentage}
                                onChange={this.__handleChange}
                                className="table-responsive"
                                min={0}
                                max={100}
                            />
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__filter-row settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="purchase-order-item-list-fields">
                                <Translate contentKey="merchantAccount.lastName">
                                    Purchase Order Item List Columns
                                </Translate>
                            </Label>
                            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                                <MultiSelect
                                    inputId="purchase-order-item-list-fields"
                                    display="chip"
                                    value={this.state.merchantBranchSettings.purchaseOrderItemListFields}
                                    name="purchaseOrderItemListFields"
                                    disabled={!this.state.productPriceButtonRender}
                                    onChange={this.__handleChangeMerchantBranchSettings}
                                    optionLabel="name"
                                    optionValue="value"
                                    options={PURCHASE_ORDER_ITEM_LIST_FIELDS}
                                    placeholder="Select fields"
                                    style={{ flex: 1 }}
                                />
                                <Button
                                    color="outline-primary"
                                    disabled={!this.state.productPriceButtonRender}
                                    onClick={() => {
                                        this.setState(prev => ({
                                            merchantBranchSettings: {
                                                ...prev.merchantBranchSettings,
                                                purchaseOrderItemListFields: []
                                            }
                                        }));
                                    }}
                                >
                                    <Translate contentKey="entity.action.reset">Reset</Translate>
                                </Button>
                            </div>
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="print-queue-till-user-bss-id">
                                <Translate contentKey="contactManagement.mobilePhone">Default Till User
                                </Translate>
                            </Label>
                            <AvField
                                id="print-queue-till-user-bss-id"
                                type="select"
                                disabled={!this.state.productPriceButtonRender}
                                className="table-responsive"
                                name="printQueueTillUserBssId"
                                value={this.state.merchantBranchSettings.printQueueTillUserBssId}
                                onChange={this.__handleChange}>
                                <option value="" key=''>
                                    Select
                                </option>
                                {this.state.tillUserList.map(element => (
                                    <option value={element.bssId} key={element.bssId}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="till-price-calculation-method">
                                <Translate contentKey="merchantAccount.emailAddress">Price Calculation Method</Translate>
                            </Label>
                            <AvField
                                id="till-price-calculation-method"
                                type="select"
                                disabled={!this.state.productPriceButtonRender}
                                className="table-responsive"
                                name="tillPriceCalculationMethod"
                                value={this.state.merchantBranchSettings.tillPriceCalculationMethod}
                                onChange={this.__handleChange}>
                                {TILL_PRICE_CALCULATION_METHOD.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {this.state.productPriceButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({
                                productPriceButtonRender: true,
                                deliverySaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {this.state.productPriceButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveMerchantBranchSettings("PRODUCTPRICE");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}

                    {this.state.productPriceButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.merchantBranchSettingsTemp;
                            this.setState({
                                merchantBranchSettings: Object.assign({}, obj1),
                                deliverySaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    };

    orderDisplaySettings() {
        return (
            <FormSection>
                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="menu-display-template">
                                <Translate contentKey="productfirstName">Menu Display Template</Translate>
                            </Label>
                            <AvField
                                id="menu-display-template"
                                type="select"
                                className="form-control"
                                name="menuDisplayTemplate"
                                disabled={!this.state.orderDisplaySettingsButtonRender}
                                value={this.state.merchantBranchSettings.menuDisplayTemplate}
                                onChange={this.__handleChange}>
                                {MENU_DISPLAY_TEMPLATE.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="menu-display-type">
                                <Translate contentKey="productfirstName">Menu Sorting</Translate>
                            </Label>
                            <AvField
                                id="menu-display-type"
                                type="select"
                                className="form-control"
                                name="menuDisplayType"
                                disabled={!this.state.orderDisplaySettingsButtonRender}
                                value={this.state.merchantBranchSettings.menuDisplayType}
                                onChange={this.__handleChange}>
                                {MENU_DISPLAY_TYPE.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="show-email-address-in-the-store-card">
                                <Translate contentKey="productfirstName">Show Email Address In The Store Card</Translate>
                            </Label>
                            <AvField
                                id="show-email-address-in-the-store-card"
                                type="select"
                                className="form-control"
                                name="showEmailAddressInTheStoreCard"
                                disabled={!this.state.orderDisplaySettingsButtonRender}
                                value={this.state.merchantBranchSettings.showEmailAddressInTheStoreCard}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {YESNO.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="menu-border-color">
                                <Translate contentKey="productTag.tradingName">Menu Border Color&nbsp;</Translate>
                            </Label>
                            <ColorPicker inputId="menu-border-color"
                                         value={this.state.merchantBranchSettings.menuBorderColor}
                                         format="hex"
                                         name="menuBorderColor"
                                         onChange={this.__handleChange}/>
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {this.state.orderDisplaySettingsButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({
                                deliverySaveButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: true,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                            });
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {this.state.orderDisplaySettingsButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveMerchantBranchSettings("ORDERDISPLAY");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}

                    {this.state.orderDisplaySettingsButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.merchantBranchSettingsTemp;
                            this.setState({
                                merchantBranchSettings: Object.assign({}, obj1),
                                deliverySaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    };

    marketPlaceSettings() {
        return (
            <FormSection>
                <div className="settings-page__filter-row settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="serviceable-areas">
                                <Translate contentKey="productfirstName">Extra Information(Market
                                    Place)</Translate>
                            </Label>
                            <AvField
                                id="serviceable-areas"
                                name="serviceableAreas"
                                type="text"
                                disabled={!this.state.marketPlaceSaveButtonRender}
                                value={this.state.merchantBranchSettings.serviceableAreas}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {this.state.marketPlaceSaveButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({
                                deliverySaveButtonRender: false,
                                marketPlaceSaveButtonRender: true,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {this.state.marketPlaceSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveMerchantBranchSettings("MARKETPLACE");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}

                    {this.state.marketPlaceSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.merchantBranchSettingsTemp;
                            this.setState({
                                merchantBranchSettings: Object.assign({}, obj1),
                                deliverySaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    };

    basketSettingDetails() {
        return (
            <FormSection>
                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="distance-from-postal-code-that-can-be-serviced">
                                <Translate contentKey="productfirstName">Distance(miles) From Postcode that can
                                    be serviced</Translate>
                            </Label>
                            <AvField
                                id="distance-from-postal-code-that-can-be-serviced"
                                name="distanceFromPostalCodeThatCanBeServiced"
                                type="number"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.distanceFromPostalCodeThatCanBeServiced}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="minimum-delivery-basket-price">
                                <Translate contentKey="productfirstName">Minimum Delivery Basket
                                    Total</Translate>
                            </Label>
                            <InputNumber
                                inputId="minimum-delivery-basket-price"
                                name="minimumDeliveryBasketPrice"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.minimumDeliveryBasketPrice}
                                onChange={this.__handleChange}
                                mode="currency"
                                className="table-responsive"
                                currency="GBP" locale="en-US"
                            />
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="delivery-fee">
                                <Translate contentKey="productfirstName">Delivery Fee</Translate>
                            </Label>
                            <InputNumber
                                inputId="delivery-fee"
                                name="deliveryFee"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.deliveryFee}
                                onChange={this.__handleChange}
                                mode="currency"
                                className="table-responsive"
                                currency="GBP" locale="en-US"
                            />
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="free-delivery-amount">
                                <Translate contentKey="productfirstName">Free Delivery Amount</Translate>
                            </Label>
                            <InputNumber
                                inputId="free-delivery-amount"
                                name="freeDeliveryAmount"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.freeDeliveryAmount}
                                onChange={this.__handleChange}
                                mode="currency"
                                className="table-responsive"
                                currency="GBP" locale="en-US"
                            />
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="service-charge-options">
                                <Translate contentKey="merchantAccount.emailAddress">Collection Service Charge
                                    Options</Translate>
                            </Label>
                            <AvField
                                id="service-charge-options"
                                type="select"
                                className="form-control"
                                name="serviceChargeOptions"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.serviceChargeOptions}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {SERVICE_CHARGE_OPTIONS.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="default-service-charge">
                                <Translate contentKey="merchantAccount.emailAddress">Collection Default Service
                                    Charge</Translate>
                            </Label>
                            <AvField
                                id="default-service-charge"
                                type="select"
                                className="form-control"
                                name="defaultServiceCharge"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.defaultServiceCharge}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {SERVICE_CHARGE_DEFAULT_VALUE.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="service-charge-options-table-order">
                                <Translate contentKey="merchantAccount.emailAddress">Table Order Service Charge
                                    Options</Translate>
                            </Label>
                            <AvField
                                id="service-charge-options-table-order"
                                type="select"
                                className="form-control"
                                name="serviceChargeOptionsTableOrder"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.serviceChargeOptionsTableOrder}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {SERVICE_CHARGE_OPTIONS.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="default-service-charge-table-order">
                                <Translate contentKey="merchantAccount.emailAddress">Table Order Default Service
                                    Charge</Translate>
                            </Label>
                            <AvField
                                id="default-service-charge-table-order"
                                type="select"
                                className="form-control"
                                name="defaultServiceChargeTableOrder"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.defaultServiceChargeTableOrder}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {SERVICE_CHARGE_DEFAULT_VALUE.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="service-charge-options-delivery">
                                <Translate contentKey="merchantAccount.emailAddress">Delivery Service Charge
                                    Options</Translate>
                            </Label>
                            <AvField
                                id="service-charge-options-delivery"
                                type="select"
                                className="form-control"
                                name="serviceChargeOptionsDelivery"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.serviceChargeOptionsDelivery}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {SERVICE_CHARGE_OPTIONS.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="default-service-charge-delivery">
                                <Translate contentKey="merchantAccount.emailAddress">Delivery Default Service
                                    Charge</Translate>
                            </Label>
                            <AvField
                                id="default-service-charge-delivery"
                                type="select"
                                className="form-control"
                                name="defaultServiceChargeDelivery"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.defaultServiceChargeDelivery}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {SERVICE_CHARGE_DEFAULT_VALUE.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="scheduled-for-delivery">
                                <Translate contentKey="merchantAccount.emailAddress">Scheduled for Delivery?</Translate>
                            </Label>
                            <AvField
                                id="scheduled-for-delivery"
                                type="select"
                                className="form-control"
                                name="scheduledForDelivery"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.scheduledForDelivery}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {YESNO.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="minimum-delivery-delivery-duration">
                                <Translate contentKey="productfirstName">Minimum Delivery Duration(Min)</Translate>
                            </Label>
                            <AvField
                                id="minimum-delivery-delivery-duration"
                                name="minimumDeliveryDeliveryDuration"
                                type="number"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.minimumDeliveryDeliveryDuration}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </div>

                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="maximum-delivery-delivery-duration">
                                <Translate contentKey="productfirstName">Maximum Delivery Duration(Min)</Translate>
                            </Label>
                            <AvField
                                id="maximum-delivery-delivery-duration"
                                name="maximumDeliveryDeliveryDuration"
                                type="number"
                                disabled={!this.state.deliverySaveButtonRender}
                                value={this.state.merchantBranchSettings.maximumDeliveryDeliveryDuration}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__actions">
                    {this.state.deliverySaveButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({
                                deliverySaveButtonRender: true,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {this.state.deliverySaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveMerchantBranchSettings("DELIVERY");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}

                    {this.state.deliverySaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.merchantBranchSettingsTemp;
                            this.setState({
                                merchantBranchSettings: Object.assign({}, obj1),
                                deliverySaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                marketPlaceSaveButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    };


    renderScheduleHourSelect(fieldName, label) {
        return (
            <div className="settings-page__filter-field">
                <AvGroup>
                    <Label for={fieldName}>{label}</Label>
                    <AvField
                        id={fieldName}
                        type="select"
                        className="form-control"
                        name={fieldName}
                        disabled={!this.state.branchSchedulesButtonRender}
                        value={this.state.merchantBranchSettings[fieldName] || ''}
                        onChange={this.__handleChange}>
                        <option value="" key=""/>
                        {HOUR_AND_MINUTE.map(element => (
                            <option value={element.value} key={element.value}>
                                {element.name}
                            </option>))}
                    </AvField>
                </AvGroup>
            </div>
        );
    }

    renderWeeklyOpenCloseHoursSection(openSuffix, closeSuffix, openLabelSuffix, closeLabelSuffix, copyOpenSuffix, copyCloseSuffix) {
        const days = [
            ['monday', 'Monday'],
            ['tuesday', 'Tuesday'],
            ['wednesday', 'Wednesday'],
            ['thursday', 'Thursday'],
            ['friday', 'Friday'],
            ['saturday', 'Saturday'],
            ['sunday', 'Sunday'],
        ];

        return (
            <div className="settings-page__schedule-grid">
                {days.map(([day, dayLabel], index) => (
                    <React.Fragment key={day}>
                        {this.renderScheduleHourSelect(
                            `${day}${openSuffix}`,
                            `${dayLabel} ${openLabelSuffix}`
                        )}
                        {this.renderScheduleHourSelect(
                            `${day}${closeSuffix}`,
                            `${dayLabel} ${closeLabelSuffix}`
                        )}
                        <div className="settings-page__schedule-grid__action">
                            {index === 0 ? (
                                <Button type="button" color="outline-primary"
                                        className="settings-page__btn--edit settings-page__btn--wrap settings-page__schedule-copy-btn"
                                        disabled={!this.state.branchSchedulesButtonRender}
                                        onClick={() => this.copyMondayAcrossWeek(copyOpenSuffix, copyCloseSuffix)}>
                                    <Translate contentKey="branchSettings.copyMondayToAll">Copy to all</Translate>
                                </Button>
                            ) : (
                                <span className="settings-page__schedule-grid__action-spacer" aria-hidden="true"/>
                            )}
                        </div>
                    </React.Fragment>
                ))}
            </div>
        );
    }


    setChecked = (name, value) => {
        let merchantBranchSettings = this.state.merchantBranchSettings;
        merchantBranchSettings[name] = merchantBranchSettings;
        this.setState({merchantBranchSettings: merchantBranchSettings});
    }


    copyMondayAcrossWeek = (openSuffix, closeSuffix) => {
        const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        const src = this.state.merchantBranchSettings;
        const monOpen = src['monday' + openSuffix];
        const monClose = src['monday' + closeSuffix];
        const next = {...src};
        days.forEach((d) => {
            next[d + openSuffix] = monOpen;
            next[d + closeSuffix] = monClose;
        });
        this.setState({merchantBranchSettings: next});
    };

    copyMondayRetailHoursToWeek = () => {
        const src = this.state.merchantBranchSettings;
        const v = src.mondayRetailHours;
        const next = {...src};
        ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach((d) => {
            next[d + 'RetailHours'] = v;
        });
        this.setState({merchantBranchSettings: next});
    };

    renderRetailDeliveryHoursSection() {
        const days = [
            ['mondayRetailHours', 'Monday'],
            ['tuesdayRetailHours', 'Tuesday'],
            ['wednesdayRetailHours', 'Wednesday'],
            ['thursdayRetailHours', 'Thursday'],
            ['fridayRetailHours', 'Friday'],
            ['saturdayRetailHours', 'Saturday'],
            ['sundayRetailHours', 'Sunday'],
        ];

        return (
            <div className="settings-page__schedule-grid settings-page__schedule-grid--retail">
                {days.map(([dayKey, dayLabel], index) => {
                    const value = this.state.merchantBranchSettings[dayKey] || '';
                    return (
                        <React.Fragment key={dayKey}>
                            <div className="settings-page__filter-field settings-page__schedule-grid__retail-hours">
                                <AvGroup>
                                    <Label for={dayKey}>
                                        <Translate contentKey={`merchantAccount.${dayKey}`}>{dayLabel}</Translate>
                                    </Label>
                                    <MultiSelect
                                        inputId={dayKey}
                                        value={value ? value.split(',') : []}
                                        onChange={(e) => {
                                            const selected = e.value;
                                            this.setState(prevState => ({
                                                merchantBranchSettings: {
                                                    ...prevState.merchantBranchSettings,
                                                    [dayKey]: selected.join(',')
                                                }
                                            }));
                                        }}
                                        options={RETAIL_HOUR_AND_MINUTE}
                                        optionLabel="name"
                                        display="chip"
                                        disabled={!this.state.branchSchedulesButtonRender}
                                        placeholder="Select Hour"
                                        maxSelectedLabels={3}
                                        className="w-full md:w-20rem"
                                    />
                                </AvGroup>
                            </div>
                            <div className="settings-page__schedule-grid__action">
                                {index === 0 ? (
                                    <Button type="button" color="outline-primary"
                                            className="settings-page__btn--edit settings-page__btn--wrap settings-page__schedule-copy-btn"
                                            disabled={!this.state.branchSchedulesButtonRender}
                                            onClick={this.copyMondayRetailHoursToWeek}>
                                        <Translate contentKey="branchSettings.copyMondayToAll">Copy to all</Translate>
                                    </Button>
                                ) : (
                                    <span className="settings-page__schedule-grid__action-spacer" aria-hidden="true"/>
                                )}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }

    branchSchedules() {
        const sectorUpper = (this.state.merchantBranchSettings.sector || '').toUpperCase();
        const showHospitalityDelivery = sectorUpper === 'HOSPITALITY';
        const showRetailDelivery = sectorUpper === 'RETAIL';

        const scheduleTabs = [
            {
                id: 'open-close',
                label: 'Opening & Closing',
                content: this.renderWeeklyOpenCloseHoursSection(
                    'OpenHour',
                    'CloseHour',
                    'Open',
                    'Close',
                    'OpenHour',
                    'CloseHour'
                ),
            },
        ];

        if (showHospitalityDelivery) {
            scheduleTabs.push({
                id: 'delivery-hospitality',
                label: 'Delivery (Hospitality)',
                content: this.renderWeeklyOpenCloseHoursSection(
                    'DeliveryOpenHour',
                    'DeliveryCloseHour',
                    'From',
                    'To',
                    'DeliveryOpenHour',
                    'DeliveryCloseHour'
                ),
            });
        }

        if (showRetailDelivery) {
            scheduleTabs.push({
                id: 'delivery-retail',
                label: 'Delivery (Retail)',
                content: this.renderRetailDeliveryHoursSection(),
            });
        }

        scheduleTabs.push({
            id: 'ordering',
            label: 'Ordering Hours',
            content: this.renderWeeklyOpenCloseHoursSection(
                'OrderingOpenHour',
                'OrderingCloseHour',
                'Open',
                'Close',
                'OrderingOpenHour',
                'OrderingCloseHour'
            ),
        });

        const safeScheduleTabIndex = this.state.activeScheduleTabIndex >= scheduleTabs.length
            ? 0
            : this.state.activeScheduleTabIndex;

        return (
            <>
                <SettingsTabNav
                    className="settings-page__schedule-tabs"
                    activeIndex={safeScheduleTabIndex}
                    onTabChange={(index) => this.setState({activeScheduleTabIndex: index})}
                    tabs={scheduleTabs}
                />

                <div className="settings-page__actions">
                    {this.state.branchSchedulesButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({
                                endOfDaySaveButtonRender: false,
                                deliverySaveButtonRender: false,
                                branchSchedulesButtonRender: true,
                                marketPlaceSaveButtonRender: false,
                                productPriceButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {this.state.branchSchedulesButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveMerchantBranchSettings("branchScheduling");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}

                    {this.state.branchSchedulesButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.merchantBranchSettingsTemp;
                            this.setState({
                                merchantBranchSettings: Object.assign({}, obj1),
                                marketPlaceSaveButtonRender: false,
                                endOfDaySaveButtonRender: false,
                                deliverySaveButtonRender: false,
                                branchSchedulesButtonRender: false,
                                productPriceButtonRender: false,
                                orderDisplaySettingsButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </>
        );
    };

    saveMerchantBranchSettings = (option) => {
        if (option == "EOF") {
            if (GeneralUtils.isNullOrEmpty(this.state.merchantBranchSettings.email)) {
                return toast.warn("Please fill the required fields!");
            } else if (this.state.merchantBranchSettings.isAutoEndOfDay && GeneralUtils.isNullOrEmpty(this.state.merchantBranchSettings.endOfDayHour)) {
                return toast.warn("Please fill the End Of Day Hour");
            }
        } else if (option == "PRODUCTPRICE") {
            if (!GeneralUtils.isNullOrEmpty(this.state.merchantBranchSettings.priceCalculationMethod) && (this.state.merchantBranchSettings.priceCalculationMethod != "EMPTY") && GeneralUtils.isNullOrEmpty(this.state.merchantBranchSettings.priceCalculationRate)) {
                return toast.warn("Please fill the rate field!");

            }
        }


        if (!GeneralUtils.isNullOrEmpty(this.state.merchantBranchSettings.id)) {

            this.merchantBranchSettingsService.update(this.state.merchantBranchSettings)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            endOfDaySaveButtonRender: false,
                            merchantBranchSettings: response,
                            deliverySaveButtonRender: false,
                            branchSchedulesButtonRender: false,
                            productPriceButtonRender: false,
                            marketPlaceSaveButtonRender: false,
                            orderDisplaySettingsButtonRender: false,
                            merchantBranchSettingsTemp: Object.assign({}, response)

                        });
                    }
                });
        } else {
            this.merchantBranchSettingsService.create(this.state.merchantBranchSettings)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            endOfDaySaveButtonRender: false,
                            merchantBranchSettings: response,
                            deliverySaveButtonRender: false,
                            branchSchedulesButtonRender: false,
                            productPriceButtonRender: false,
                            marketPlaceSaveButtonRender: false,
                            orderDisplaySettingsButtonRender: false,
                            merchantBranchSettingsTemp: Object.assign({}, response)
                        });
                    }
                });
        }

    }

    __handleChangeMerchantBranchSettings = (e) => {
        const { name, value } = e;

        this.setState(prevState => ({
            merchantBranchSettings: {
                ...prevState.merchantBranchSettings,
                ["purchaseOrderItemListFields"]: value   // List<String>
            }
        }));
    };

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let merchantBranchSettings = this.state.merchantBranchSettings;
        merchantBranchSettings[e.target.name] = value;
        if (e.target.name == "isAutoEndOfDay" && value == "false") {
            merchantBranchSettings["endOfDayHour"] = null;
        } else if (e.target.name == "serviceChargeOptions" && (value == "" || value == "PASSIVE")) {
            merchantBranchSettings["defaultServiceCharge"] = null;
        }else if (e.target.name == "serviceChargeOptionsTableOrder" && (value == "" || value == "PASSIVE")) {
            merchantBranchSettings["defaultServiceChargeTableOrder"] = null;
        }else if (e.target.name == "serviceChargeOptionsDelivery" && (value == "" || value == "PASSIVE")) {
            merchantBranchSettings["defaultServiceChargeDelivery"] = null;
        }
        else if (e.target.name == "priceCalculationMethod" && value == "EMPTY") {
            merchantBranchSettings["priceCalculationRate"] = null;
        }


        this.setState({merchantBranchSettings: merchantBranchSettings});
    }

}

